import {
  ChangeDetectionStrategy, Component, createNgModule, OnInit, ViewChild, ViewContainerRef,
  Injector,
  ComponentRef,
  Input, OnChanges, 
  inject, DestroyRef,
  
} from '@angular/core';


  import { FeatureToggleService } from 'ish-core/feature-toggle.module';
  import { takeUntilDestroyed } from '@angular/core/rxjs-interop';


import type { ProductNotificationEditComponent as OriginalComponent } from '../../shared/product-notification-edit/product-notification-edit.component';

@Component({
  selector: 'ish-lazy-product-notification-edit',
  templateUrl: './lazy-product-notification-edit.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class LazyProductNotificationEditComponent implements OnInit , OnChanges {
  /*
   * WARNING!
   *
   * This file was automatically generated!
   * It should be updated using:
   *
   * ng g lazy-component extensions/product-notifications/shared/product-notification-edit/product-notification-edit.component.ts
   *
   */

  @ViewChild('anchor', { read: ViewContainerRef, static: true }) anchor: ViewContainerRef;


  @Input() productNotification: OriginalComponent['productNotification'];

  @Input() displayType: OriginalComponent['displayType'];

  @Input() cssClass: OriginalComponent['cssClass'];


  private component: ComponentRef<OriginalComponent>;
   private destroyRef = inject(DestroyRef);

  constructor(
    private featureToggleService: FeatureToggleService,
    private injector: Injector
  ) {}

   ngOnInit() {
     this.featureToggleService.enabled$('productNotifications').pipe(takeUntilDestroyed(this.destroyRef)).subscribe(async enabled => {
      if (enabled) {
    

      await this.renderComponent();

    
        } else {
          this.anchor.clear();
        }
      })
    
  }

  private async renderComponent() {
    const module = await import(`../../product-notifications.module`).then(m => m.ProductNotificationsModule);

    const { ProductNotificationEditComponent: originalComponent } = await import('../../shared/product-notification-edit/product-notification-edit.component');

    const ngModuleRef = createNgModule(module, this.injector);

    this.component = this.anchor.createComponent(originalComponent, { ngModuleRef });
  
    this.ngOnChanges(
      
    );
  
    this.component.changeDetectorRef.markForCheck();
  }


  ngOnChanges() {
    if (this.component) {
      
        this.component.instance.productNotification = this.productNotification;
      
        this.component.instance.displayType = this.displayType;
      
        this.component.instance.cssClass = this.cssClass;
      

      
    }
  }

}
